// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnStyle_default__BnUNt,
.btnStyle_outlined__VZJlk,
.btnStyle_secondary__s-vx-,
.btnStyle_destructive__bK-xR,
.btnStyle_approve__BKWL0,
.btnStyle_link__tTLm6,
.btnStyle_disabled__R8iPX {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  text-transform: capitalize;
  background-color: var(--brand);
  border-radius: var(--border-radius);
  padding: 8px 16px;
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--white);
  border: 1px solid transparent;
  letter-spacing: 0.3px;
  line-height: 1.3;
  transition: all 0.2s ease-in-out;
  text-align: center;
}
.btnStyle_default__BnUNt img,
.btnStyle_default__BnUNt svg,
.btnStyle_outlined__VZJlk img,
.btnStyle_outlined__VZJlk svg,
.btnStyle_secondary__s-vx- img,
.btnStyle_secondary__s-vx- svg,
.btnStyle_destructive__bK-xR img,
.btnStyle_destructive__bK-xR svg,
.btnStyle_approve__BKWL0 img,
.btnStyle_approve__BKWL0 svg,
.btnStyle_link__tTLm6 img,
.btnStyle_link__tTLm6 svg,
.btnStyle_disabled__R8iPX img,
.btnStyle_disabled__R8iPX svg {
  width: 18px;
  height: 18px;
}
.btnStyle_default__BnUNt.btnStyle_sm__fEEd5,
.btnStyle_outlined__VZJlk.btnStyle_sm__fEEd5,
.btnStyle_secondary__s-vx-.btnStyle_sm__fEEd5,
.btnStyle_destructive__bK-xR.btnStyle_sm__fEEd5,
.btnStyle_approve__BKWL0.btnStyle_sm__fEEd5,
.btnStyle_link__tTLm6.btnStyle_sm__fEEd5,
.btnStyle_disabled__R8iPX.btnStyle_sm__fEEd5 {
  font: var(--body-font-four);
  padding: 7px 12px;
}
.btnStyle_default__BnUNt.btnStyle_lg__5JfF2,
.btnStyle_outlined__VZJlk.btnStyle_lg__5JfF2,
.btnStyle_secondary__s-vx-.btnStyle_lg__5JfF2,
.btnStyle_destructive__bK-xR.btnStyle_lg__5JfF2,
.btnStyle_approve__BKWL0.btnStyle_lg__5JfF2,
.btnStyle_link__tTLm6.btnStyle_lg__5JfF2,
.btnStyle_disabled__R8iPX.btnStyle_lg__5JfF2 {
  min-height: 40px;
  padding: 10px 16px;
}
.btnStyle_default__BnUNt:active, .btnStyle_default__BnUNt:hover,
.btnStyle_outlined__VZJlk:active,
.btnStyle_outlined__VZJlk:hover,
.btnStyle_secondary__s-vx-:active,
.btnStyle_secondary__s-vx-:hover,
.btnStyle_destructive__bK-xR:active,
.btnStyle_destructive__bK-xR:hover,
.btnStyle_approve__BKWL0:active,
.btnStyle_approve__BKWL0:hover,
.btnStyle_link__tTLm6:active,
.btnStyle_link__tTLm6:hover,
.btnStyle_disabled__R8iPX:active,
.btnStyle_disabled__R8iPX:hover {
  box-shadow: var(--shadowxsoffset-x) var(--shadowxsoffset-y) var(--shadowxsblur-radius) var(--shadowxsspread-radius) rgba(49, 49, 49, 0.0509803922);
  background-color: #96b8ca;
}
.btnStyle_default__BnUNt:focus,
.btnStyle_outlined__VZJlk:focus,
.btnStyle_secondary__s-vx-:focus,
.btnStyle_destructive__bK-xR:focus,
.btnStyle_approve__BKWL0:focus,
.btnStyle_link__tTLm6:focus,
.btnStyle_disabled__R8iPX:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.btnStyle_default__BnUNt:disabled,
.btnStyle_outlined__VZJlk:disabled,
.btnStyle_secondary__s-vx-:disabled,
.btnStyle_destructive__bK-xR:disabled,
.btnStyle_approve__BKWL0:disabled,
.btnStyle_link__tTLm6:disabled,
.btnStyle_disabled__R8iPX:disabled {
  cursor: not-allowed;
  background-color: var(--secondary-Text);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  opacity: 0.5;
}

.btnStyle_secondary__s-vx- {
  background-color: #f2f6f8;
  color: var(--primary-Text);
}
.btnStyle_secondary__s-vx-:hover {
  background-color: #e9edf0;
}
.btnStyle_secondary__s-vx-:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.btnStyle_secondary__s-vx-:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f2f6f8;
}

.btnStyle_destructive__bK-xR {
  background-color: var(--error);
  color: var(--white);
}
.btnStyle_destructive__bK-xR:hover {
  background-color: #f6695e;
}
.btnStyle_destructive__bK-xR:focus {
  box-shadow: 0px 0px 0px 3px #fcc5c1;
}
.btnStyle_destructive__bK-xR:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--error);
}

.btnStyle_outlined__VZJlk {
  background-color: var(--white);
  color: var(--primary-Text);
  border: 1px solid var(--border);
  box-shadow: 0px 0px 0px 3px rgba(197, 196, 196, 0.0509803922);
}
.btnStyle_outlined__VZJlk:hover {
  background-color: #f2f6f8;
}
.btnStyle_outlined__VZJlk:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.btnStyle_outlined__VZJlk:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--white);
}
.btnStyle_outlined__VZJlk.btnStyle_active__c1ptT {
  background-color: var(--brand);
  color: var(--white);
  border-color: var(--brand);
}
.btnStyle_outlined__VZJlk.btnStyle_active__c1ptT img,
.btnStyle_outlined__VZJlk.btnStyle_active__c1ptT svg {
  filter: brightness(0) invert(1);
}
.btnStyle_outlined__VZJlk.btnStyle_active__c1ptT:hover {
  background-color: #96b8ca;
}

.btnStyle_approve__BKWL0 {
  background-color: var(--success);
  color: var(--white);
}
.btnStyle_approve__BKWL0:hover {
  background-color: #83c085;
}
.btnStyle_approve__BKWL0:focus {
  box-shadow: 0px 0px 0px 3px rgba(197, 196, 196, 0.0509803922);
}
.btnStyle_approve__BKWL0:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: var(--success);
}

.btnStyle_link__tTLm6 {
  background-color: transparent;
  border: unset;
  color: var(--primary-Text);
  box-shadow: unset;
}
.btnStyle_link__tTLm6:hover {
  background-color: transparent;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.btnStyle_link__tTLm6:focus {
  box-shadow: 0px 0px 0px 3px #d6e3eb;
}
.btnStyle_link__tTLm6:disabled {
  cursor: not-allowed;
  background-color: transparent;
  opacity: 0.5;
  box-shadow: unset;
  text-decoration: unset;
}

.btnStyle_pilled__5Wm9a {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;
  font: var(--body-font-three);
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.3;
  background-color: var(--white);
  color: var(--brand);
  border: 1px solid #e8ebee;
  border-radius: 20px;
  min-height: 40px;
  text-transform: capitalize;
  width: 100%;
}
.btnStyle_pilled__5Wm9a:hover, .btnStyle_pilled__5Wm9a:focus, .btnStyle_pilled__5Wm9a:active, .btnStyle_pilled__5Wm9a:active {
  background-color: var(--brand);
  color: var(--white);
}
.btnStyle_pilled__5Wm9a:hover img,
.btnStyle_pilled__5Wm9a:hover svg, .btnStyle_pilled__5Wm9a:focus img,
.btnStyle_pilled__5Wm9a:focus svg, .btnStyle_pilled__5Wm9a:active img,
.btnStyle_pilled__5Wm9a:active svg, .btnStyle_pilled__5Wm9a:active img,
.btnStyle_pilled__5Wm9a:active svg {
  filter: brightness(0) invert(1);
}

@media (max-width: 991px) {
  .btnStyle_default__BnUNt,
  .btnStyle_contained__Q5Vgw,
  .btnStyle_secondary__s-vx-,
  .btnStyle_outlined__VZJlk,
  .btnStyle_approve__BKWL0 {
    font-size: 12px;
    padding: 7px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/button/btnStyle.module.scss"],"names":[],"mappings":"AACA;;;;;;;EAOC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;EACA,8BAAA;EACA,mCAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AAAD;AAEC;;;;;;;;;;;;;;EAEC,WAAA;EACA,YAAA;AAYF;AATC;;;;;;;EACC,2BAAA;EACA,iBAAA;AAiBF;AAdC;;;;;;;EACC,gBAAA;EACA,kBAAA;AAsBF;AAnBC;;;;;;;;;;;;;EAEC,kJAAA;EACA,yBAAA;AAgCF;AA7BC;;;;;;;EACC,mCAAA;AAqCF;AAlCC;;;;;;;EACC,mBAAA;EACA,uCAAA;EACA,+CAAA;EACA,YAAA;AA0CF;;AArCA;EACC,yBAAA;EACA,0BAAA;AAwCD;AAtCC;EACC,yBAAA;AAwCF;AArCC;EACC,mCAAA;AAuCF;AApCC;EACC,mBAAA;EACA,YAAA;EACA,yBAAA;AAsCF;;AAjCA;EACC,8BAAA;EACA,mBAAA;AAoCD;AAlCC;EACC,yBAAA;AAoCF;AAjCC;EACC,mCAAA;AAmCF;AAhCC;EACC,mBAAA;EACA,YAAA;EACA,8BAAA;AAkCF;;AA7BA;EACC,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,6DAAA;AAgCD;AA9BC;EACC,yBAAA;AAgCF;AA7BC;EACC,mCAAA;AA+BF;AA5BC;EACC,mBAAA;EACA,YAAA;EACA,8BAAA;AA8BF;AA3BC;EACC,8BAAA;EACA,mBAAA;EACA,0BAAA;AA6BF;AA3BE;;EAEC,+BAAA;AA6BH;AA1BE;EACC,yBAAA;AA4BH;;AAtBA;EACC,gCAAA;EACA,mBAAA;AAyBD;AAvBC;EACC,yBAAA;AAyBF;AAtBC;EACC,6DAAA;AAwBF;AArBC;EACC,mBAAA;EACA,YAAA;EACA,gCAAA;AAuBF;;AAlBA;EACC,6BAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;AAqBD;AAnBC;EACC,6BAAA;EACA,0BAAA;EACA,0BAAA;AAqBF;AAlBC;EACC,mCAAA;AAoBF;AAjBC;EACC,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAmBF;;AAfA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;AAkBD;AAhBC;EAIC,8BAAA;EACA,mBAAA;AAeF;AAbE;;;;;EAEC,+BAAA;AAkBH;;AAbA;EAEC;;;;;IAKC,eAAA;IACA,iBAAA;EAeA;AACF","sourcesContent":["// Contained variant button\r\n.default,\r\n.outlined,\r\n.secondary,\r\n.destructive,\r\n.approve,\r\n.link,\r\n.disabled {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\ttext-transform: capitalize;\r\n\tbackground-color: var(--brand);\r\n\tborder-radius: var(--border-radius);\r\n\tpadding: 8px 16px;\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 500;\r\n\tcolor: var(--white);\r\n\tborder: 1px solid transparent;\r\n\tletter-spacing: 0.3px;\r\n\tline-height: 1.3;\r\n\ttransition: all 0.2s ease-in-out;\r\n\ttext-align: center;\r\n\r\n\timg,\r\n\tsvg {\r\n\t\twidth: 18px;\r\n\t\theight: 18px;\r\n\t}\r\n\r\n\t&.sm {\r\n\t\tfont: var(--body-font-four);\r\n\t\tpadding: 7px 12px;\r\n\t}\r\n\r\n\t&.lg {\r\n\t\tmin-height: 40px;\r\n\t\tpadding: 10px 16px;\r\n\t}\r\n\r\n\t&:active,\r\n\t&:hover {\r\n\t\tbox-shadow: var(--shadowxsoffset-x) var(--shadowxsoffset-y) var(--shadowxsblur-radius) var(--shadowxsspread-radius) #3131310d;\r\n\t\tbackground-color: #96b8ca;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground-color: var(--secondary-Text);\r\n\t\tbox-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\r\n\t\topacity: 0.5;\r\n\t}\r\n}\r\n\r\n// secondary variant button\r\n.secondary {\r\n\tbackground-color: #f2f6f8;\r\n\tcolor: var(--primary-Text);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #e9edf0;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: #f2f6f8;\r\n\t}\r\n}\r\n\r\n// destructive variant button\r\n.destructive {\r\n\tbackground-color: var(--error);\r\n\tcolor: var(--white);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #f6695e;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #fcc5c1;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--error);\r\n\t}\r\n}\r\n\r\n// Outlined variant button\r\n.outlined {\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--primary-Text);\r\n\tborder: 1px solid var(--border);\r\n\tbox-shadow: 0px 0px 0px 3px #c5c4c40d;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #f2f6f8;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--white);\r\n\t}\r\n\r\n\t&.active {\r\n\t\tbackground-color: var(--brand);\r\n\t\tcolor: var(--white);\r\n\t\tborder-color: var(--brand);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\tfilter: brightness(0) invert(1);\r\n\t\t}\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: #96b8ca;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// approve variant button\r\n.approve {\r\n\tbackground-color: var(--success);\r\n\tcolor: var(--white);\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #83c085;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #c5c4c40d;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\topacity: 0.5;\r\n\t\tbackground-color: var(--success);\r\n\t}\r\n}\r\n\r\n// Link variant button\r\n.link {\r\n\tbackground-color: transparent;\r\n\tborder: unset;\r\n\tcolor: var(--primary-Text);\r\n\tbox-shadow: unset;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: transparent;\r\n\t\ttext-decoration: underline;\r\n\t\ttext-underline-offset: 2px;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: 0px 0px 0px 3px #d6e3eb;\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground-color: transparent;\r\n\t\topacity: 0.5;\r\n\t\tbox-shadow: unset;\r\n\t\ttext-decoration: unset;\r\n\t}\r\n}\r\n\r\n.pilled {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\tpadding: 8px 16px;\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 500;\r\n\tletter-spacing: 0.3px;\r\n\tline-height: 1.3;\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--brand);\r\n\tborder: 1px solid #e8ebee;\r\n\tborder-radius: 20px;\r\n\tmin-height: 40px;\r\n\ttext-transform: capitalize;\r\n\twidth: 100%;\r\n\r\n\t&:hover,\r\n\t&:focus,\r\n\t&:active,\r\n\t&:active {\r\n\t\tbackground-color: var(--brand);\r\n\t\tcolor: var(--white);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\tfilter: brightness(0) invert(1);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\r\n\t.default,\r\n\t.contained,\r\n\t.secondary,\r\n\t.outlined,\r\n\t.approve {\r\n\t\tfont-size: 12px;\r\n\t\tpadding: 7px 10px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default": `btnStyle_default__BnUNt`,
	"outlined": `btnStyle_outlined__VZJlk`,
	"secondary": `btnStyle_secondary__s-vx-`,
	"destructive": `btnStyle_destructive__bK-xR`,
	"approve": `btnStyle_approve__BKWL0`,
	"link": `btnStyle_link__tTLm6`,
	"disabled": `btnStyle_disabled__R8iPX`,
	"sm": `btnStyle_sm__fEEd5`,
	"lg": `btnStyle_lg__5JfF2`,
	"active": `btnStyle_active__c1ptT`,
	"pilled": `btnStyle_pilled__5Wm9a`,
	"contained": `btnStyle_contained__Q5Vgw`
};
export default ___CSS_LOADER_EXPORT___;
